import React from 'react';

const Header = () => {
    return (
        <div className="navigation">
            <div className="container">
                <div className="row">
                    <nav className="navbar navbar-toggleable-md navbar-inverse">
                        <a href="https://cademonline.cl" target="_blank" rel="noreferrer" className="navbar-brand" id="logo">
                            <img src="assets/images/logo-cadem-online.svg" alt="Logo CademOnline" style={{ height: '70px', width: '180px' }} className="img-responsive" />
                        </a>
                        <div id="branding">
                            <a href="https://www.instagram.com/cadem_online/?hl=es-la" target="_blank" rel="noreferrer"><img src="assets/images/instagram.png" alt="Logo Instagram"  style={{ height: '50px' }} /></a>
                            <a href="https://es-la.facebook.com/panelcademonline" target="_blank" rel="noreferrer"><img src="assets/images/facebook.png" alt="Logo Facebook"  style={{ height: '50px' }} /></a>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    )
}

export default Header;
